<template>
  <v-container>
    <v-card class="center mr-7 ml-7" flat>
      <img :src="logo" id="image" />
      <h2 class="pb-3" id="title">{{ displayTitle }}</h2>
      <v-divider />
      <p class="pt-3" id="text" v-html="text"></p>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LoginCardDescription extends Vue {
  @Prop()
  logo!: string;

  @Prop()
  title!: string;

  @Prop()
  text!: string;

  get displayTitle() {
    if (this.$route.path.indexOf("/logout") != -1) {
      return this.$t("components.login.LoginCardDescription.logoutTitle");
    }
    return this.title;
  }

  constructor() {
    super();
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  position: relative;
}
.center {
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
#image {
  max-width: 80%;
  max-height: 30%;
}
#title {
  font-weight: 700;
  font-size: 95% !important;
}
#text {
  font-weight: 500;
  font-size: 60% !important;
}
</style>
